import React, { useState, useEffect } from 'react';
import { ComposableMap, Geographies, Geography, ZoomableGroup } from 'react-simple-maps';
import { scaleQuantile } from 'd3-scale';
import { Tooltip } from 'react-tooltip';
import { northeastGDPData } from '../api/economyData';

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const northeastStates = [
  "Connecticut", "Maine", "Massachusetts", "New Hampshire",
  "Rhode Island", "Vermont", "New York", "New Jersey", "Pennsylvania"
];

const NortheastGDPMap = () => {
  const [gdpChangeData, setGdpChangeData] = useState([]);

  useEffect(() => {
    setGdpChangeData(northeastGDPData || []);
  }, []);

  // Ensure gdpChangeData is an array
  const safeGdpChangeData = Array.isArray(gdpChangeData) ? gdpChangeData : [];

  // Only create the color scale if we have data
  const colorScale = safeGdpChangeData.length > 0 
    ? scaleQuantile()
        .domain(safeGdpChangeData.map(d => d.QoQ_Growth_Rate))
        .range([
          "#e5f5e0",
          "#c7e9c0",
          "#a1d99b",
          "#74c476",
          "#41ab5d",
          "#238b45",
          "#006d2c"
        ])
    : () => "#EEE"; // Default color function if no data

  const sortedData = [...safeGdpChangeData].sort((a, b) => b.QoQ_Growth_Rate - a.QoQ_Growth_Rate);

  return (
    <div className="flex flex-col md:flex-row justify-between items-start">
      <div className="w-full md:w-1/2 mb-4 md:mb-0">
        <ComposableMap projection="geoAlbersUsa">
          <ZoomableGroup center={[-74, 43]} zoom={3}>
            <Geographies geography={geoUrl}>
              {({ geographies }) =>
                geographies
                  .filter(geo => northeastStates.includes(geo.properties.name))
                  .map(geo => {
                    const cur = safeGdpChangeData.find(s => s && s.state === geo.properties.name);
                    return (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        fill={cur ? colorScale(cur.QoQ_Growth_Rate) : "#EEE"}
                        stroke="#FFF"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={`${geo.properties.name}: ${cur ? cur.QoQ_Growth_Rate.toFixed(1) + '%' : 'N/A'}`}
                        style={{
                          hover: {
                            fill: "#F53",
                            outline: "none"
                          }
                        }}
                      />
                    );
                  })
              }
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>
        <Tooltip id="my-tooltip" />
      </div>
      <div className="w-full md:w-1/2 pl-0 md:pl-4 flex flex-col items-center">
        <h3 className="text-xl font-semibold mb-2">Quarterly GDP Change Ranking</h3>
        <div className="inline-block text-left">
          <ol className="list-decimal list-inside" style={{ fontSize: '1.4rem' }}>
            {sortedData.map((item, index) => (
              <li key={item.state} className="mb-1">
                {item.state}: {item.QoQ_Growth_Rate.toFixed(1)}%
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default NortheastGDPMap;